import { Mocker, makeMocker } from "./mock-common";
import { StatusEnum } from "../api-types/status";

export const mockSimpleStatusResponse: Mocker<{ status: StatusEnum }> = makeMocker<{ status: StatusEnum }>({
  status: StatusEnum.NOT_STARTED,
});
